import React, { useRef, useEffect } from 'react'
import styled from 'styled-components'
import { useReadOnly, ReactEditor } from 'vendor/slate-react'
import { Path, Node, Transforms } from 'vendor/slate'
import { HINT_TYPES, HINT_TYPES_BY_KEY } from 'cg/components/documents/editor/slate/types'

const Hint = ({ attributes, children, element, editor }) => {
  const readOnly = useReadOnly()
  const { hintType } = element
  const { color, icon, key } = hintType || {}

  const onClick = () => {
    if (readOnly) return

    const path = ReactEditor.findPath(editor, element)
    const index = HINT_TYPES_BY_KEY.indexOf(key)
    const newKey = HINT_TYPES_BY_KEY[index + 1] ? HINT_TYPES_BY_KEY[index + 1] : HINT_TYPES_BY_KEY[0]
    Transforms.setNodes(editor, { hintType: HINT_TYPES[newKey] }, { at: path })
  }

  return (
    <HintContainer {...attributes} color={color} readOnly={readOnly}>
      <HintIconContainer contentEditable={false} style={{ userSelect: 'none' }}>
        <HintIcon className={icon} color={color} readOnly={readOnly} onClick={onClick} />
      </HintIconContainer>
      {children}
    </HintContainer>
  )
}

export default Hint

const HintContainer = styled.div`
  background: ${props => props.theme.bgLightestInverse};
  border-radius: 3px;
  border-left: 3px solid;
  border-left-color: ${props => (props.color ? props.color : props.theme.borderColor)};
  margin: 15px 0px 15px;
  overflow: ${props => (props.readOnly ? 'hidden' : null)};
`
const HintIconContainer = styled.div`
  padding: 15px 15px 10px 15px;
`

const HintIcon = styled.i`
  font-size: 23px;
  cursor: ${props => (props.readOnly ? 'inherit' : 'pointer')};
  color: ${props => (props.color ? props.color : 'inherit')};
`
